import { Chip, Stack } from '@mui/material'
import type { EmployeeRolesProps } from './types'

export const EmployeeRoles = ({ roles }: EmployeeRolesProps) => {
  return (
    <Stack gap={'4px'}>
      {!!roles &&
        roles.length > 0 &&
        roles.map((role: string, index) => (
          <Chip
            key={index}
            sx={{
              inlineSize: 'fit-content',
              maxHeight: '24px',
              backgroundColor: '#009FDA',
              color: '#FFFFFF',
              fontFamily: 'Roboto',
              fontWeight: '500',
              fontSize: '14px',
              lineHeight: '16px',
              '& .MuiChip-label': {
                padding: '2px 8px',
              },
              borderRadius: '4px',
              pointerEvents: 'none',
            }}
            label={role}
          ></Chip>
        ))}
    </Stack>
  )
}
